import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n/configPages';
import App from './App';

const rootElement = document.getElementById('root');

// react-snap prerendering: if the root already has children (prerendered HTML),
// hydrate instead of render so the static HTML is interactive immediately.
// This also helps SEO crawlers that don't execute JS see the full page content.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
